import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

import './styles/YellowGreenButton.scss';

const YellowGreenButton = ({
  text,
  style,
  onClick,
  buttonClass,
  ...restParams
}) => (
  <div className="yellow-green-button-wrapper">
    <Button
      onClick={ onClick }
      buttonClass={ `yellow-green-button ${buttonClass} ` }
      style={ style }
      text={ text }
      { ...restParams }
    />
  </div>
);

YellowGreenButton.propTypes = {
  style: PropTypes.shape({}),
  text: PropTypes.string,
  onClick: PropTypes.func,
  buttonClass: PropTypes.string
};

YellowGreenButton.defaultProps = {
  style: {},
  text: '',
  onClick: () => {},
  buttonClass: ''
};

export default YellowGreenButton;



// WEBPACK FOOTER //
// ./src/components/YellowGreenButton.js